<div class="relative bg-warm-card overflow-hidden">
  <!-- Close button (hidden while retrying) -->
  @if (!(retrying$ | async)) {
    <div class="absolute top-3 right-3 z-20">
      <ds-button variant="ghost" [iconOnly]="true" dsDialogClose aria-label="Close dialog">
        <span class="material-symbols-outlined icon-size-token-md">close</span>
      </ds-button>
    </div>
  }

  <!-- Content -->
  <div class="flex flex-col items-center text-center px-8 pt-10 pb-8">
    <!-- Illustration -->
    <div class="relative w-64 h-64 flex items-center justify-center mb-6">
      <!-- ds-token-exempt: decorative-error-numeral (FD-065) -->
      <span
        class="absolute text-[180px] font-extrabold text-warm-border-light select-none tracking-tighter opacity-50"
      >
        0
      </span>

      <!-- Isometric decoration -->
      <div
        class="absolute w-32 h-2 top-0 right-0 bg-gradient-to-r from-warm-border-light to-warm-border rounded skew-x-12 opacity-20"
      ></div>
      <div
        class="absolute w-2 h-32 bottom-0 left-0 bg-gradient-to-b from-warm-border-light to-warm-border rounded skew-y-12 opacity-20"
      ></div>

      <!-- Icon card -->
      <div
        class="z-10 bg-warm-card p-8 rounded-2xl shadow-xl border border-warm-border-light flex flex-col items-center"
      >
        <div
          class="w-20 h-20 bg-[var(--color-bg-subtle-primary,rgba(15,23,42,0.06))] rounded-full flex items-center justify-center mb-4"
        >
          @if (retrying$ | async) {
            <span
              class="inline-block w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"
            ></span>
          } @else {
            <span class="material-symbols-outlined !text-5xl text-primary">wifi_off</span>
          }
        </div>
        <div class="flex gap-2">
          @if (retrying$ | async) {
            <div class="w-2 h-2 rounded-full bg-primary animate-pulse"></div>
            <div
              class="w-2 h-2 rounded-full bg-primary animate-pulse [animation-delay:150ms]"
            ></div>
            <div
              class="w-2 h-2 rounded-full bg-primary animate-pulse [animation-delay:300ms]"
            ></div>
          } @else {
            <div class="w-2 h-2 rounded-full bg-primary/40"></div>
            <div class="w-2 h-2 rounded-full bg-primary/40"></div>
            <div class="w-2 h-2 rounded-full bg-primary"></div>
          }
        </div>
      </div>
    </div>

    <!-- Text -->
    <div class="space-y-4 max-w-md">
      @if (retrying$ | async) {
        <h1 class="text-warm-text text-2xl font-semibold tracking-tight">
          {{ 'Errors.Retrying' | translate }}
        </h1>
        <p class="text-warm-secondary text-sm leading-relaxed">
          {{ 'Errors.RetryingDescription' | translate }}
        </p>
      } @else {
        <h1 class="text-warm-text text-2xl font-semibold tracking-tight">
          {{ 'Errors.ConnectionLost' | translate }}
        </h1>
        <p class="text-warm-secondary text-sm leading-relaxed">
          {{ 'Errors.ConnectionLostDescription' | translate }}
        </p>
      }
    </div>

    <!-- Button -->
    <div class="pt-8">
      <ds-button
        variant="primary"
        [disabled]="!!(retrying$ | async)"
        [loading]="!!(retrying$ | async)"
        (click)="retry()"
      >
        @if (!(retrying$ | async)) {
          <span class="material-symbols-outlined icon-size-token-sm mr-2">refresh</span>
        }
        {{ (retrying$ | async) ? ('Errors.Retrying' | translate) : ('Action.Retry' | translate) }}
      </ds-button>
    </div>
  </div>

  <!-- Footer -->
  <div class="border-t border-warm-border-light py-4 w-full text-center opacity-50">
    <p class="text-token-label font-medium block text-warm-secondary dark:text-neutral-200 mb-1">
      {{ 'ErrorPages.Footer' | translate }}
    </p>
  </div>
</div>
